var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TableCard',{ref:"table",attrs:{"title":"Locais de estoque","headers":[
      {
        value: 'nome',
        text: 'Nome'
      },
      {
        value: 'cliente_nome',
        text: 'Cliente'
      },
      {
        value: 'endereco_cliente_string',
        text: 'Endereço'
      }
    ],"indexer":_vm.api.locais_de_estoque.indexar,"hideSearch":""},on:{"click:add":function($event){return _vm.adicionarLocalEstoqueDialogo()}},scopedSlots:_vm._u([{key:"item.nome",fn:function(ref){
    var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'locais_de_estoque_page', params: { id: item.id } }}},[_vm._v(" "+_vm._s(item.nome)+" ")])]}}])}),_c('DialogoLista',{ref:"produtos",attrs:{"title":"Produtos","emptyMessage":"Nenhum produto encontrado","width":500,"itemTitle":"produto_nome","itemIcon":"mdi-chevron-right","itemKey":"id","actions":[
      {
        name: 'add',
        text: 'Adicionar',
        color: 'primary',
        icon: 'mdi-plus'
      },
      {
        name: 'move',
        text: 'Transferir',
        color: 'primary',
        icon: 'mdi-transfer'
      },
      {
        name: 'remove',
        text: 'Remover',
        color: 'red',
        icon: 'mdi-delete',
        dark: true
      }
    ]},on:{"click:add":_vm.handleOpenDialogoFormulario},scopedSlots:_vm._u([{key:"item.title",fn:function(ref){
    var item = ref.item;
return [_c('b',[_vm._v(_vm._s(item.produto_nome))]),_vm._v(" (x"+_vm._s(item.quantidade)+") ")]}}])}),_c('DialogoFormulario',{ref:"dialogoFormulario",attrs:{"title":"Adicionar produto","handler":_vm.handleAddProduto},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var form = ref.form;
    var errors = ref.errors;
return [_c('ServerSelectField',{attrs:{"label":"Produto","error-messages":errors.produto,"loader":_vm.api.products.index,"itemText":"nome","itemValue":"id"},model:{value:(form.produto),callback:function ($$v) {_vm.$set(form, "produto", $$v)},expression:"form.produto"}}),_c('v-text-field',{attrs:{"label":"Quantidade","type":"number","error-messages":errors.produto},model:{value:(form.quantidade),callback:function ($$v) {_vm.$set(form, "quantidade", $$v)},expression:"form.quantidade"}})]}}])}),_c('DialogoTransferirEstoque',{ref:"transferirEstoque"}),_c('AdicionarLocalEstoqueDialogo',{ref:"adicionarLocalEstoqueDialogo",on:{"adicionado":function($event){return _vm.$refs.table.loadItems()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }